/**
 * Form Radio Group Component
 * Uses CSS modules for styling with theme variables
 */

import React from 'react';
import styles from './FormRadioGroup.module.css';

const FormRadioGroup = ({
  label,
  name,
  value,
  options = [],
  onChange,
  error,
  required = false,
  disabled = false,
  className = ''
}) => {
  const radioInputClasses = [
    styles.radioInput,
    error ? styles.error : ''
  ].filter(Boolean).join(' ');

  return (
    <div className={`${styles.container} ${className}`}>
      {label && (
        <label className={styles.groupLabel}>
          {label}
          {required && <span className={styles.required}> *</span>}
        </label>
      )}

      <div className={styles.radioGroup} role="radiogroup" aria-required={required}>
        {options.map((option) => (
          <label key={option.value} className={styles.radioItem}>
            <input
              type="radio"
              name={name}
              value={option.value}
              checked={value === option.value}
              onChange={onChange}
              disabled={disabled}
              required={required}
              className={radioInputClasses}
              aria-checked={value === option.value}
            />
            <span className={styles.radioLabel}>{option.label}</span>
          </label>
        ))}
      </div>

      {error && (
        <div role="alert" aria-live="polite" className={styles.errorMessage}>
          {error}
        </div>
      )}
    </div>
  );
};

export { FormRadioGroup };
export default FormRadioGroup;